<!-- Update views/guides/guide.html.erb in tandom -->
<div class="guide-preview content-card">
  <a href="/{{guide_slug}}">
    <div class="image-container">
      {{#image_animated}}
        <video class="video-preview" preload="auto" muted="muted" loop="loop"
          playsinline poster="{{cropped_image_standard}}">
          <source src="{{cropped_image_mp4}}" type="video/mp4">
          <source src="{{cropped_image_webm}}" type="video/webm">
          Your browser does not support the video tag.
        </video>
      {{/image_animated}}
      {{^image_animated}}
        <img src="{{cropped_image_standard}}" class="image-preview" alt="{{title}}, {{tagline}}">
      {{/image_animated}}

      <div class="overlay">
        <div class="tagline">
          {{tagline}}
        </div>
      </div>
    </div>
  </a>

  <div class="bottom-section">
    <div class="content">
      <a href="/{{guide_slug}}" class="title">{{title}}</a>

      <div class="author">
        By
        <a href="/u/{{user.username}}" data-turbo="false">
          <span class="name"> {{user.name}}</span>
        </a>
      </div>
    </div>

    <div class="badges">
      {{#favorites_count}}
        <div class="badge favorites" title="Saves"></div>
      {{/favorites_count}}

      <div class="badge" title="<%= guide.skill_level.titleize %>">
        {{skill_level}}
      </div>
    </div>
  </div>
</div>
